import styled from 'styled-components';
import { FlexDiv } from '@shared/components/base/Div';

export const TaggedCampaignWrapper = styled(FlexDiv)`
    height: 50px;
    flex-direction: column;
    justify-content: center;
`;
